import { useTranslationStore } from '../../../stores/useTranslationStore';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { EpButton } from '../../EpButton';
import { EpCloseNotificationModal } from '../components/EpCloseNotificationModal';

export const FormStepButtonClose = ({
  closeNotificationRoute,
}: {
  closeNotificationRoute: string;
}) => {
  const { translations } = useTranslationStore((state) => state);

  return (
    <>
      <EpButton
        buttonId="btn-close-notification"
        buttonSize="md"
        buttonType="secondary-outline"
        buttonDataBsTarget="#close-notification-modal"
        buttonDataBsToggle="modal"
        buttonLeftIconName="SolidSignOutAlt"
        buttonText={t(translations['global'], 'Exit')}
      />
      <EpCloseNotificationModal
        closeNotificationRoute={closeNotificationRoute}
      />
    </>
  );
};
